<template>
  <div class="postview" >
    <section class="header" v-if="selectedPost">
      <div class="title" >{{ selectedPost.title }}</div>
      <div class="post_info">
        <span class="nametag"> 
          <user-name-tag :user="selectedPost.user" 
          :displaymytalk="false" :displayProfileImage="false" :lineheight="true"/>
        </span>
        <p>조회 {{ selectedPost.count }}</p>
        <p>추천 {{ selectedPost.recommend }}</p>
        <p class="post-created_at"><date-time :time="selectedPost.created_at" type="2"/></p>
      </div>
      <div class="btn_wrap"> 
        <a href="javascript:void(0)"
          @click="postSearch(selectedPost.user.id)"
        >게시글 보기</a>  
        <a href="javascript:void(0)"
          @click="popMessage(selectedPost.user.nic)"
        >쪽지보내기</a>
        <a href="javascript:void(0)"
          @click="addFriend(selectedPost.user.nic)"
        >친구추가</a>
        <!-- <a href="">게시글보기</a>
       
        <a href="">채팅신청</a> -->

        <template v-if="currentUser.id === selectedPost.user.id || currentUser.role === 'admin'">
          <a href="javascript:void(0)" @click="postEdit" class="btn_edit">수정하기</a>

          <template v-if="reqdel === 0">
            <a href="javascript:void(0)" @click="reqDelete" class="btn_reqDelete">삭제요청</a>
          </template>
           <template v-else>
            <a href="javascript:void(0)" class="btn_waitingdel">삭제처리대기중</a>
          </template>

        </template>

        <template v-if="currentUser.role === 'admin'">
          <a href="javascript:void(0)" @click="postDelete"   class="btn_delete">삭제</a>
        </template>
      </div>
    </section>
    <section class="body">
      <div v-if="selectedPost">         
        <video v-if="selectedPost.attachfile" class="attachfile" :src="attatchfileUrl(selectedPost.attachfile)" controls></video>  
      </div>
      <div class="ckeditor_view">
        <ckeditor :editor="editor" :disabled="editorDisabled" :model-value="editorData"></ckeditor>
      </div>
      
      <div class="reco" v-if="selectedPost">
        <post-recommend :count="selectedPost.recommend" :postid="selectedPost.id" :currentRecommend="selectedPost.recommends"/>
      </div>
    </section>
    <section class="reply" v-if="selectedPost">
        <post-comment-form :postid="selectedPost.id"  @save-comment="saveComment"/>
        
        <post-comment  @delete-comment="deleteComment" :postid="selectedPost.id"/>
    </section>
    <section class="footer">
        <div class="btn_post_list">
            <a href="javascript:void(0)" @click="viewList()">목록</a>
        </div>
    </section>
  </div>
</template>

<script>
//import CKEditor from '@ckeditor/ckeditor5-vue';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';


import DateTime from "@/components/site/parts/DisplayTime";
import PostComment from "@/components/posts/PostComment"
import PostCommentForm from "@/components/posts/PostCommentForm"
import PostRecommend from "@/components/posts/PostRecommend"
import { newPop } from '@/utils/popup.js';
import { auth } from "@/components/mixins/auth.js"
import { commentSubmit } from "@/components/mixins/commentSubmit.js"
export default {
  name:'mobile_postview',
  props: ["id","searchview"],
  data() {
    return {
      selectedPost: null,
      viewer: "",
      comment:"",
      editor:DecoupledEditor,
      editorData: '<p>데이터를 불러옵니다.</p>',
      editorDisabled: true,  
          
    };
  },
  components:{    
      DateTime,
      PostCommentForm,
      PostComment,
      PostRecommend,
      //ckeditor: CKEditor.component
  },
  mixins:[auth,commentSubmit],
  computed: {
    getId() {
      return parseInt(this.id);
    },
    getContent() {
      // console.log(this.selectedPost);
      // if (this.selectedPost) {
      //   return this.selectedPost.content;
      // } else {
      //   return this.selectedPost;
      // }
      return this.$store.state.posts.viewpost;
    },  
    
    currentUser(){
      return this.$store.getters.currentUser;
    },
    reqdel()
    {
      if( this.$store.state.posts.viewpost)
      {
          return this.$store.state.posts.viewpost.req_del;
      }else{
          return 0;
      }
    }
  },
  watch: {
    getId() {
     this.updatePost();
     this.updateViewer()
    },
  },
  mounted(){
    this.getPost();

  },
  methods: {
    // getComments(){
    //   if(this.$store.state.menu.activeSubMenu ==="gameqna")
    //   {
    //     return this.getContent.comments;
    //   }else{
    //     return this.getContent.comments.reverse();
    //   }
      
    // },
    attatchfileUrl(fileUrl){
      return this.$store.state.serverDomain2+'storage/'+fileUrl;
    },
    postSearch(userId)
    {
      this.$router.push({ name: 'postsearch', params: { user_id: userId }})
    },
    popMessage(nic)
    {      
      const url="/pop/message/Write/"+nic;
      newPop('Msg_window',url,'','',800,400);
    },
    postEdit(){
      //console.log('현재 뷰포스트',this.$store.state.posts.viewpost);
      this.$router.push({ name: 'postedit', params: { postdata:this.selectedPost.id }})
    },
    reqDelete(){
        if(confirm('삭제처리시 지급된 포인트는 회수 됩니다. \n삭제요청을 하시겠습니까?'))
        {
            this.sendreqDel();
        }
    },
    postDelete()
    {
        if(confirm('삭제 하시겠습니까?'))
        {
            this.sendDel();
        }
    },
    viewList(){
      const menu = this.$store.state.menu.activeMenu;
      const submenu = this.$store.state.menu.activeSubMenu;
      let path ="/m/community/" + menu +"/"+ submenu
      if(this.searchview)
      {
        path ="/m/myinfo/posts";
      }
        this.$router.push({
          path: path
        });
    },
    async sendreqDel(){
      try {
        let response = await this.$store.dispatch("posts/reqDelete", this.selectedPost.id)
        this.$flashMessage.show({type: response.state,title: response.message,message: response.message,});
        //console.log(this.$store.state.posts.viewpost);
        }catch(error)
        {
          console.log(error);
      }
    },
    async sendDel(){
      try {
        let response = await this.$store.dispatch("posts/Delete", this.selectedPost.id);        
        this.$flashMessage.show({type: response.state,title: response.message,message: response.message,});
        this.$router.go(-1);
        //console.log(this.$store.state.posts.viewpost);
        }catch(error)
        {
          console.log(error);
      }
    },
    async getPost(){
        try {
            let response='';
            //새로고침 했을때는 디비에서 값을 가져오게
            // if(this.$store.getters["posts/getposts"].data)
            // {
                // response = await this.$store.getters["posts/getposts"].data.find(
                // (post) => post.id === this.getId);
            // }else{
                //로그인 유저아이디를 던져서 추천을 했는지 체크
                const formData={
                    //user_id:1,
                    user_id:this.$store.getters.currentUser.id,
                    post_id:this.id
                }
                 response = await this.$store.dispatch("posts/getPost", formData)
            // }

        this.selectedPost = response.post;
        console.log('뷰포스트',response.post);
        this.updateViewer()
        }catch(error)
        {
            console.log(error);
        }
    },
    updatePost() {
      this.selectedPost = this.$store.getters["posts/getposts"].data.find(
        (post) => post.id === this.getId
      );
    },
    updateViewer() {
      this.editorData =  this.selectedPost.content;
    },    
    deleteComment(id)
    {
      const findItem = this.selectedPost.comments.find((comment)=>comment.id === id);
      const idx = this.selectedPost.comments.indexOf(findItem);
      this.selectedPost.comments.splice(idx,1);      
    },
    // replaceMedia(content)
    // {
    //   const step1 = content.split('<figure class="media"><oembed url="');
    //   if( step1.length === 1)
    //   {
    //     return content;
    //   }
    //   const step2 = step1[1].split('"></oembed></figure>');
    //   return step2[0];

    // },
    // modifyUrl(url) {
    //   //혹시 나중에 참조할것을 위해 남겨둠
    //   let endpoint = url; endpoint = endpoint.replace('oembed', 'iframe');
    //   endpoint = endpoint.replace('url', 'src');
    //   endpoint = endpoint.replace('watch?v=', 'embed/');
    //   endpoint = endpoint.replace('oembed', 'iframe');
    //   return endpoint;
    // }
  },
};
</script>
<style>
.ckeditor_view .ck-content figure{
  outline:none !important
}
.ckeditor_view .ck-content .image{
  outline:none !important
}
.ckeditor_view .ck-content .image>figcaption {
  display:none !important
}
</style>
<style lang="scss" scoped>
.attachfile{
  width:100%;
  height:300px;
}
.postview {
  background: #fff;
  
  margin-bottom: 10px;
  .header {
    padding: 20px 10px 20px;
    border-bottom: 1px solid #dee3eb;
    .title{
        margin-bottom: 23px;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
    }
    .post_info{
        display:flex;
        height:23px;
        font-size: 12px;
        color:#a3a3a3;   
        align-items: center;
        .nametag{
          color:#000;
        }    
        p:before {
            content: "";
            display: block;
           float: left;
            margin: 8px 10px 0 10px;
            width: 1px;
            height: 1px;
            background: #000;
        }
        p{
            margin:0;           
            letter-spacing: -.02em;
        }
        .post-created_at{
          flex:1 auto;
        }
    }
    .btn_wrap{
            padding-top:15px;
            a{
                display: inline-block;
                padding: 0 10px;
                height: 23px;
                line-height: 23px;
                border: 1px solid #e2e2e2;
                color: #737373;
                background: #fff;
                margin-left:5px;
                font-size:12px;
            }
            .btn_edit{
              border:1px solid red;
              color:red;
            }
            .btn_reqDelete{
              border:1px solid blue;
              color:blue;
            }
            .btn_waitingdel{
              border:1px solid gray;
              color:gray;
            }
            .btn_delete{
              background:red;
              color:white;
            }
        }
  }
  .body {
    margin: 5px 0 20px;
    padding: 0 5px;
    overflow: auto;
    .reco{
        padding: 60px 40px 20px 0;
    }
  }
  .reply{
      padding: 25px 5px 0;
  }
  .footer{
    margin-top: 0;
    padding: 20px 30px;
    background: #fafafa;
    border-top: 1px solid #ebeef3;
    display:flex;
    justify-content: flex-end;
    .btn_post_list{
        a{
            padding: 13px 18px 12px;
            font-size: 12px;
        }
    }
  }
}
</style>
